var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(2)])
                  : _vm._e()
              ]),
              _vm._m(3)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(4),
                _vm._m(5),
                true
                  ? _c("div", { staticClass: "summary" }, [_vm._m(6)])
                  : _vm._e()
              ]),
              _vm._m(7)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("정기적금(개인용)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v("매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("NZD")]),
        _c("span", { staticClass: "text" }, [_vm._v("최대 연")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v("5.50%")]),
      _c("div", { staticClass: "etc" }, [_vm._v("(아래참조)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("정기적금")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v("매월 일정한 금액을 저축하여 목돈을 마련하는 적립식 상품")
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [_vm._v("실명의 개인")]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [
          _vm._v(" 최저 1년 ~ 최장 3년(년단위)"),
          _c("br"),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(
              "12개월 초과 정기예적금 상품은 비대면 채널을 통한 가입이 어려우므로 신규를 원하시는 경우 영업점으로 문의 부탁드립니다."
            )
          ])
        ]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("NZD")]),
        _c("dt", [_vm._v("가입금액")]),
        _c("dd", [_vm._v("신규가입 시 최저 NZD 100.00(약정불입액)")]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd", [_vm._v("약정이율")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(연이율, 세전, 단위 : %)")
      ]),
      _c("table", { staticClass: "table -type02" }, [
        _c("colgroup", [
          _c("col", { attrs: { width: "40%" } }),
          _c("col", { attrs: { width: "25%" } }),
          _c("col")
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row", rowspan: "3" } }, [
              _vm._v("정기적금조회")
            ]),
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1년")]),
            _c("td", [_vm._v("5.50%")])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2년")]),
            _c("td", [_vm._v("4.60%")])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3년")]),
            _c("td", [_vm._v("4.60%")])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [_vm._v("· 중도해지이율 : 약정이율 x 예금기간별 적용금리")]),
        _c("p", [
          _vm._v(
            "· 만기후이율 : 약정이율 x ½ (1년 이내) / 약정이율 x 1% (1년 이후)"
          )
        ]),
        _c("p", [
          _vm._v(
            "· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다."
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("수수료")]),
        _c("p", [
          _vm._v(" 조기해지수수료 "),
          _c("br"),
          _vm._v(": 만기 1달전 조기해지시 부과되는 수수료 "),
          _c("br"),
          _vm._v("→ 만기금액 x 조기해지전에치기간(일) x 조기해지이율 / 365 "),
          _c("br"),
          _vm._v("* 조기해지이율 : 약정이율 + 1.5% "),
          _c("br"),
          _vm._v("* 조기해지전 예치기간(일) = 만기일자 – 조기해지일자 ")
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입방법")]),
        _c("p", [_vm._v("영업점가입, 인터넷 가입")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("가입시 필요서류")]),
        _c("p", [_vm._v("신분증 (여권 또는 NZ운전면허증), 주소지 증명서 등")]),
        _c("p", [
          _vm._v("※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("PERSONAL INSTALLMENT SAVING DEPOSIT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          "An installment product to build a savings by depositing a fixed amount every month."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("NZD")]),
        _c("span", { staticClass: "text" }, [_vm._v("Up to")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v("5.50%")]),
      _c("div", { staticClass: "etc" }, [
        _vm._v("p.a(Refer to information below)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Installment Savings Account")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            " Is it difficult to save for a specific goal or a spending plan? "
          ),
          _c("br"),
          _vm._v(
            "Whatever your goal is. KB installment savings account can help you to meet your savings goal. "
          ),
          _c("br"),
          _vm._v(
            "By opening up a KB installment savings account, you are agreeing to make monthly payments to the bank for a specific period of time. This means you are more likely to become regimented to making the monthly savings payments. "
          ),
          _c("br"),
          _vm._v(
            "KB installment savings account is an effective way to let your savings grow. "
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [_vm._v("Personal customers")]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [
          _vm._v(" From 1 year to 3 years (yearly basis)"),
          _c("br"),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v(
              "For enquiries on 12 Months exceed deposit products, please contact the branch."
            )
          ])
        ]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("NZD")]),
        _c("dt", [_vm._v("Deposit amount")]),
        _c("dd", [
          _vm._v(
            "Minimum NZD 100.00 deposit amount is required. (agreed payment)"
          )
        ]),
        _c("dt", [_vm._v("Rates")]),
        _c("dd", [_vm._v("The agreed interest rate")])
      ]),
      _c("div", { staticClass: "tbl-top-etc" }, [
        _vm._v("(annual interest rate, pretax, unit : %)")
      ]),
      _c("table", { staticClass: "table -type02" }, [
        _c("colgroup", [
          _c("col", { attrs: { width: "40%" } }),
          _c("col", { attrs: { width: "25%" } }),
          _c("col")
        ]),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row", rowspan: "3" } }, [
              _vm._v("Installment Savings Deposit")
            ]),
            _c("th", { attrs: { scope: "row" } }, [_vm._v("1year")]),
            _c("td", [_vm._v("5.50%")])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("2years")]),
            _c("td", [_vm._v("4.60%")])
          ]),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("3years")]),
            _c("td", [_vm._v("4.60%")])
          ])
        ])
      ]),
      _c("div", { staticClass: "info info-type3" }, [
        _c("p", [
          _vm._v(
            "· The Midway Break : The agreed interest x of rate equivalent to deposit period"
          )
        ]),
        _c("p", [
          _vm._v(
            "· After maturity date : The agreed interest x 1/2 (within 1 year) , Over 1 year : 1%"
          )
        ]),
        _c("p", [
          _vm._v(
            "· All savings interest rates are subject to change according to market interest rate trends."
          )
        ])
      ]),
      _c("br"),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Fees")]),
        _c("p", [
          _vm._v(" Early termination fee "),
          _c("br"),
          _vm._v(
            ": Fee that is charged for early break within 1 month from the maturity "
          ),
          _c("br"),
          _vm._v(
            "→ Total amount at maturity x Day(s) of prematurity x Prematurity Interest / 365 "
          ),
          _c("br"),
          _vm._v("* Prematurity Interest : Agreed interest rate + 1.5% "),
          _c("br"),
          _vm._v(
            "* Day(s) of prematurity = maturity date – early withdrawal date "
          )
        ])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("How to apply")]),
        _c("p", [_vm._v("Apply at the branch, Apply Online")])
      ]),
      _c("div", { staticClass: "info info-type4" }, [
        _c("strong", [_vm._v("Required documents for application")]),
        _c("p", [_vm._v("Passport or NZ driver's licence & proof of address")]),
        _c("p", [
          _vm._v(
            "※ Please contact our branch for more detailed information on required documents."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }